import React from 'react';
import { Route } from 'react-router-dom';
import { BankKurbanDialog } from './bank-kurban-dialog/BankKurbanDialog';
import { BankKurbanCard } from './BankKurbanCard';
import { BankKurbanUIProvider } from './BankKurbanUIContext';

export function BankKurbanPage({ history }) {

    const bankKurbanUIEvents = {
        newBankKurbanButtonClick: () => {
            history.push('/donasi/bank/kurban/new');
        },
        openProcessPage: (id) => {
            history.push(`/donasi/bank/${id}/kurban/process`);
        },
    };

    return (
        <BankKurbanUIProvider bankKurbanUIEvents={bankKurbanUIEvents}>
            <Route path="/donasi/bank/kurban/new">
                {({ history, match }) => (
                    <BankKurbanDialog
                        show={match != null}
                        onHide={() => {
                            history.push('/donasi/bank/kurban');
                        }}
                    />
                )}
            </Route>

            <BankKurbanCard/>
        </BankKurbanUIProvider>
    );
}
